<template>
  <div id="actionSupport">
    <el-popover placement="top" trigger="hover" popper-class="dark">
      <div>{{ $t("ActionSupport.IconPopover") }}</div>
      <div
        slot="reference"
        class="float-icon__entry"
        @click="openActionSupportDialog"
      >
        <pre>{{ $t("ActionSupport.TitleWrap") }}</pre>
      </div>
    </el-popover>

    <el-dialog
      :title="$t('ActionSupport.Title')"
      :visible.sync="isShowActionSupportDialog"
      :close-on-click-modal="false"
      width="90%"
      center
    >
      <iframe
        width="100%"
        height="100%"
        :src="link"
        frameborder="0"
      >
      </iframe>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    const comLoginToken = this.$getCookie('comLoginToken').replace('token=', '')
    const link = `${process.env.VUE_APP_ACTION_SUPPORT_WEB_URL}?timestamp=${Date.now()}&comLoginToken=${encodeURIComponent(comLoginToken)}`
    return {
      isShowActionSupportDialog: false,
      link
    }
  },
  methods: {
    openActionSupportDialog () {
      this.isShowActionSupportDialog = true
    },
    closeActionSupportDialog () {
      this.isShowActionSupportDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.float-icon__entry {
  background: $warnColor;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: map-get($fontSize,medium);
  font-weight: 700;
  text-align: center;
  color: white;
  transform: translate3d(0, 0, 0); // 使動畫更加流暢
  transition: transform ease-out 200ms;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  position: fixed;
  bottom: 435px; // 先維持既有寫死的方式，每次 + 100px
  right: 30px;
  z-index: 20;

  &:hover {
    transform: scale(1.2, 1.2) translate3d(0, 0, 0);
  }
}
::v-deep .el-dialog {
  @include basicDialog();
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
  height: 90vh;
  .el-dialog__body{
    max-height: unset;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
